var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "toaster" }, [
    _c("div", { staticClass: "toaster__header" }, [
      _c("h2", [_vm._v(" " + _vm._s(_vm.thisTitle) + " ")]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "toaster__body" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }